mutation EmailGlobalBlocklistAdd($input: EmailGlobalBlocklistAddInput!) {
    emailGlobalBlocklistAdd(input: $input) {
        blocklistedEmail {
            emailAddress
        }
    }
}
